var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dataCard.numberRegister
    ? _c("div", { staticClass: "go-card-body" }, [
        _c("div", { staticClass: "go-card-logo" }, [
          _c("img", {
            attrs: { src: this.dataCard.imageUri, alt: "Naver blog" },
          }),
          _vm._v(" "),
          _c("strong", [_vm._v(_vm._s(this.dataCard.title))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-card-btn" }, [
          _c("div", [
            _c("i", { staticClass: "go-icon-16 go-icon-public" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(this.dataCard.numberRegister) +
                  " " +
                  _vm._s(_vm.$t("cdHome.t159"))
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-btn-area" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-outline-primary",
                attrs: { type: "button" },
                on: { click: this.handleConnect },
              },
              [_vm._v(_vm._s(_vm.$t("cdHome.t178")))]
            ),
          ]),
        ]),
      ])
    : _c("div", { staticClass: "go-card-body" }, [
        _c("div", { staticClass: "go-card-logo" }, [
          _c("img", { attrs: { src: this.dataCard.imageUri, alt: "img" } }),
          _vm._v(" "),
          _c("strong", [
            _vm._v(
              _vm._s(
                _vm.dataCard.title === "Meta Search"
                  ? _vm.$t("scrap-agent.meta-search.modal")
                  : _vm.dataCard.title
              )
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "go-card-btn",
            staticStyle: {
              "align-items": "center",
              "justify-content": "center",
            },
          },
          [
            _c("div", { staticClass: "go-btn-area" }, [
              _c(
                "button",
                {
                  staticClass: "btn go-btn-outline-primary",
                  attrs: { type: "button" },
                  on: { click: this.handleConnect },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.dataCard.title === "Meta Search"
                          ? _vm.$t("scrap-agent.meta-search.connect")
                          : _vm.$t("cdHome.t178")
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ]),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }